// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { markdown16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { Icon, registerIcon } from '../icon-base';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-markdown': IconMarkdown;
    }
}

/**
 * The icon component for the 'markdown' icon
 */
export class IconMarkdown extends Icon {
    public constructor() {
        super(markdown16X16);
    }
}

registerIcon('icon-markdown', IconMarkdown);
export const iconMarkdownTag = 'nimble-icon-markdown';
